import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface TerminalDetailOption{
  device_id: string // 终端id
  page: number // 页码
  limit: number // 每页数量
  task_id?: string // 扫描批次id
  /** 处理状态，0-全部, 1-未处理，2-已处理 3-处理失败 */
  handle_status?: number
  /** 级联团队id */
  cascade_team_id?: number
}

export interface TerminalDetail{
  risk_type: string // 风险类型
  risk_item: number // 风险项
  risk_name: number // 风险名
  scan_type: string // 类型
  scan_time: number // 发现时间
  handle_time: number // 处理时间
  virus_info: string // 病毒详情
}

@Injectable()
export class TerminalViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  fetchTerminalDetail (options: TerminalDetailOption) {
    return this.http
      .post<{
        total: number,
        list: TerminalDetail[]
      }>('logmanage/terminal-virus/list', options)
  }
}
